module.exports = __webpack_public_path__ + "static/media/DesireBasic.7eb6e41d.woff";